var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Pricing'),_c('div',{staticClass:"cta-container"},[_c('SignUpCtaSection',{attrs:{"title":"Start Securing Your Apps Today"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }